/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import { initializeApollo } from 'gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import { CollezioneDocument, CollezioniDocument, PaginaDocument } from '@gql/graphql'
import { Page } from '@components/organisms'
import { CollezioneDetailTemplate } from '@components/templates'

const CollezioneDetail = ({ pagina, collezione }) => {
  return <CollezioneDetailTemplate pagina={pagina} collezione={collezione} />
}

export const getStaticPaths = NextWrapper.getStaticPaths(async ({ locales }) => {
  let paths = []

  // for (const locale of locales) {
  //   if (locale === 'default') continue

  //   const client = initializeApollo(locale)

  //   const {
  //     data: { collezioni },
  //   } = await client.query({
  //     query: CollezioniDocument,
  //   })

  //   collezioni?.forEach((x) => paths.push({ params: { slug_collezione: x.slug, slug_brand: x.brand.slug  }, locale: locale }))
  // }

  return {
    paths: paths,
    fallback: 'blocking',
  }
}, '/collezioni/brand/[slug_brand]/[slug_collezione]')

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug_collezione, slug_brand }, preview, previewData, locale }) => {
    const client = initializeApollo(locale)
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { collezione },
    } = await client.query({
      query: CollezioneDocument,
      variables: { slug: slug_collezione, brand: slug_brand, preview: preview || false },
      context: {
        headers,
      },
    })

    if (!collezione) {
      return {
        notFound: true,
      }
    }

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: {
        contentTypeId: collezione.modelPk,
        objectId: collezione.pk,
        chiave: 'collezione-detail',
        preview,
      },
      context: {
        headers,
      },
    })

    return {
      props: { collezione, pagina: pagina },
      revalidate: 60 * 20 * 24,
    }
  },
  '/collezioni/brand/[slug_brand]/[slug_collezione]'
)

export default CollezioneDetail
